import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../auth/AuthContext'
import { apiFetch } from '../api/client'

interface RotateKeyResponse {
  hmac_salt_kid: string
}

// useRotateKey hits POST /v1/glows/{id}/rotate-key. The endpoint writes
// a fresh per-glow salt slot on the glow doc — every session signed
// before this call is invalidated on the next request (CLAUDE.md §6).
// Not idempotent: each call advances the salt kid (e.g. "" → "s1" →
// "s2"), so confirm with the user before calling.
export function useRotateKey(glowID: string) {
  const { idTokenProvider } = useAuth()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      apiFetch<RotateKeyResponse>(
        `/v1/glows/${glowID}/rotate-key`,
        idTokenProvider,
        { method: 'POST' },
      ),
    onSuccess: () => {
      // The glow doc just changed — invalidate so any future PATCH or
      // settings-tab read picks up the new hmac_salt_kid value if we
      // ever surface it. No-op today since the SPA doesn't render it,
      // but keeps cache coherent for follow-ups.
      qc.invalidateQueries({ queryKey: ['glow', glowID] })
    },
  })
}
